import React , {useEffect , useState} from "react";
import MemeCard from "../components/Card";
import { getAllMemes } from "../api/memes";
import 'bootstrap/dist/css/bootstrap.min.css';



const HomePage =  () => {
    const [ data ,setData] =  useState([]);
     
      useEffect(() => { 
        getAllMemes().then((memes) => setData(memes.data.memes));
        
      } ,[])


      return (
        <div className="container mt-4">
          <div className="row">
            {data.map((el, i) => (
              <div className="col-md-4 mb-4" key={i}>
                <MemeCard img={el.url} title={el.name} />
              </div>
            ))}
          </div>
        </div>
      );
    }


export default HomePage;